import { ReactNode } from 'react';
import { Icon, Flex, Heading } from '@chakra-ui/react';
import FeatherIcon from '@ailibs/feather-react-ts';
import { PiBookOpenText, PiHandTap, PiTrophy } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import { PageContent } from 'src/components/PageContent/PageContent';
import { SectionBox } from '@/components/SectionBox';
import { ShortcutCard } from './components/ShortcutCard';
import { ReactComponent as TeamShirtIcon } from '@/assets/icons/TeamShirt.svg';
import { ReactComponent as BannerHomeIcon } from '@/assets/icons/BannerHome.svg';
import { ReactComponent as IconAccounts } from 'src/assets/images/icon-home-accounts.svg';
import { ReactComponent as BaladAppIcon } from '@/assets/icons/BaladApp-icon.svg';

type AppLink = {
  label: string;
  url: string;
  icon: ReactNode;
};

const appLinks: AppLink[] = [
  { label: 'Página Inicial', url: '/application/home', icon: <FeatherIcon name='home' /> },
  { label: 'Notícias', url: '/application/news', icon: <PiBookOpenText /> },
  { label: 'Redes Sociais', url: '/application/social-media', icon: <FeatherIcon name='thumbs-up' /> },
  { label: 'Calendário', url: '/application/calendar', icon: <FeatherIcon name='calendar' /> },
  { label: 'Competições', url: '/application/championships', icon: <PiTrophy /> },
  { label: 'Equipe', url: '/application/team', icon: <Icon as={TeamShirtIcon} /> },
  { label: 'História', url: '/application/history', icon: <FeatherIcon name='book' /> },
  { label: 'Mapa de Indicações', url: '/application/indications-map', icon: <FeatherIcon name='map-pin' /> },
  { label: 'Canal de Vídeos', url: '/application/videos-channel', icon: <FeatherIcon name='tv' /> },
  { label: 'Banners na Home', url: '/application/banners-home', icon: <Icon as={BannerHomeIcon} /> },
  { label: 'Loja', url: '/application/store', icon: <FeatherIcon name='shopping-cart' /> },
  { label: 'Áreas Interativas', url: '/application/interactive-area', icon: <Icon as={PiHandTap} /> },
  { label: 'BaladAPP', url: '/application/balada-app', icon: <Icon as={BaladAppIcon} /> },
];

const managementLinks: AppLink[] = [
  { label: 'Usuários', url: '/account', icon: <Icon as={IconAccounts} /> },
  { label: 'Parceiros', url: '/partners', icon: <FeatherIcon name='star' /> },
  { label: 'Controle de Acesso', url: '/access-control', icon: <FeatherIcon name='layers' /> },
  { label: 'Central de Comunicação', url: '/communication-central', icon: <FeatherIcon name='volume-2' /> },
];

const LinkGrid = ({ links }: { links: AppLink[] }) => (
  <Flex gap='xxsmall' flexWrap='wrap'>
    {links.map(link => (
      <Link key={link.url} to={link.url}>
        <ShortcutCard label={link.label} icon={link.icon} />
      </Link>
    ))}
  </Flex>
);

export const Home = () => {
  return (
    <PageContent gap='50px'>
      <Flex direction='column' gap='25px'>
        <Heading variant='sectionTitle'>APLICATIVO</Heading>
        <SectionBox>
          <LinkGrid links={appLinks} />
        </SectionBox>
      </Flex>

      <Flex direction='column' gap='25px'>
        <Heading variant='sectionTitle'>GESTÃO</Heading>
        <SectionBox>
          <LinkGrid links={managementLinks} />
        </SectionBox>
      </Flex>
    </PageContent>
  );
};
